// extracted by mini-css-extract-plugin
export default {"__content":"philosophy___content__7Nw6A"};